<template>
  <div :class="$vuetify.breakpoint.smAndDown ? 'ma-6 mt-4' : 'mx-2'">
    <Breadcrumbs class="mb-2" :promotionTitle="promotion.titulo" />

    <div
      v-if="promotionLoaded == false"
      :max-width="$vuetify.breakpoint.smAndDown ? 400 : ''"
    >
      <v-skeleton-loader
        type="card"
        :max-width="$vuetify.breakpoint.smAndDown ? 400 : ''"
        class="mx-auto"
      />
    </div>
    <div
      v-else
      class="d-flex"
      :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'"
      style="width: 100%"
    >
      <ConfirmActivatePromotionDialog
        :dialog="confirmActivatePromotionDialog"
        :promotion="currentUserPromotion"
        :newPromotion="newPromotion"
        @closeDialog="confirmActivatePromotionDialog = false"
      >
      </ConfirmActivatePromotionDialog>

      <v-card
        :max-width="$vuetify.breakpoint.smAndDown ? '' : 500"
        height="100%"
        class="colorDominant d-flex flex-column mt-0 pb-4"
        :class="$vuetify.breakpoint.smAndDown ? 'mb-6' : 'my-4'"
      >
        <v-img
          v-show="promotion.codigo"
          cover
          position="top"
          :max-height="$vuetify.breakpoint.smAndDown ? 400 : 200"
          :src="promotion.image"
          @error="imageError({ src: promotion.image, code: promotion.codigo })"
        ></v-img>

        <v-card-title>
          {{ promotion.titulo }}
        </v-card-title>

        <v-card-text>
          <v-row
            align="center"
            class="mx-0 text-subtitle-1"
            v-if="promotion.bonus_max && Number(promotion.bonus_max) > 0"
          >
            <p style="color: LimeGreen; font-weight: bold;">
              {{ $t("promotionMaxBonus", { max_bonus: promotion.bonus_max }) }}
            </p>
          </v-row>
          <v-row
            align="center"
            class="mx-0 text-subtitle-1"
            v-else-if="promotion.bonus && Number(promotion.bonus) > 0"
          >
            <p style="color: LimeGreen; font-weight: bold;">
              {{ $t("promotionMaxBonus", { max_bonus: promotion.bonus }) }}
            </p>
          </v-row>

          <div class="my-4 text-subtitle-2">
            {{ promotion.descricao }}
          </div>
        </v-card-text>

        <div class="align-self-end" style="width: 100%">
          <v-divider class="mx-2"></v-divider>
          <v-card-actions style="width: 100%">
            <v-btn
              @click="activatePromotion"
              class="primary block"
              style="width: 100%"
              :loading="loading"
              :disabled="loading"
            >
              {{ $t("joinPromotion") }}
            </v-btn>
          </v-card-actions>
        </div>

        <v-card-actions class="d-flex flex-column pa-2">
          <div class="pa-2 align-self-start">
            {{ $t("howItWorks") }}
          </div>
          <div v-html="promotion.funcionamento" class="mx-4"></div>
        </v-card-actions>
      </v-card>
      <v-card
        class="colorDominant mt-0"
        :class="$vuetify.breakpoint.smAndDown ? 'mb-6' : 'my-4 ml-4'"
      >
        <v-card-text>
          <div v-html="promotion.regras"></div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs";
import ConfirmActivatePromotionDialog from "./ConfirmActivatePromotionDialog";

export default {
  data: () => ({
    promotion: {},
    promotionLoaded: false,
    expandFunctioningDetail: true,
    confirmActivatePromotionDialog: false,
    loading: false,
    currentUserPromotion: {},
    newPromotion: {},
    possibleExtensions: ["png", "jpg", "jpeg", "webp"],
  }),

  components: { ConfirmActivatePromotionDialog, Breadcrumbs },

  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    this.confirmActivatePromotionDialog = false;

    this.fetchPromotion();
  },

  methods: {
    fetchPromotion() {
      const body = {
        domain: this.$domain(),
        promotion_id: this.$route.params.promotion_id,
      };

      this.$axios
        .post("/promotion/listPromotion", this.$formdata(body))
        .then((res) => {
          const promotion = res.data.dados;

          promotion.image = encodeURI(
            `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${
              promotion.codigo
            }.${this.possibleExtensions[0]}`
          );

          this.promotion = promotion;
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });

          this.backToAllPromotions();
        })
        .finally(() => {
          this.promotionLoaded = true;
        });
    },

    async activatePromotion() {
      this.loading = true;

      const promotionType = this.promotion.tipo;
      const code = this.promotion.codigo ? this.promotion.codigo : this.promotion.code_promo;

      if (promotionType == "cadastro") {
        this.$store.commit("showDialogRegister", true);
        this.$store.commit("setCurrentRegisterPromotionCode", code);
      } else if (promotionType == "1ºdeposito" || promotionType == "deposito") {
        if (!this.$store.state.logged.status) {
          this.loading = false;
          this.$store.commit("showDialogRegister", true);
          return;
        }

        localStorage.setItem(
          "depositPromotionCodeFromPromotions", JSON.stringify(code)
        );

        this.$store.commit("dialogDeposit", true);
        this.$store.commit("setCurrentDepositPromotionCode", code);
      }

      this.loading = false;
    },

    userPromotion() {
      return this.$axios
        .post("/player/bonus/promotion/listActives")
        .then((res) => {
          return res.data.dados.active_promotion;
        })
        .catch(() => {
          return false;
        });
    },

    backToAllPromotions() {
      this.$router.push({ name: "AllPromotions" });
    },

    imageError({ src, code }) {
      let currExtension = src.split(".")[src.split(".").length - 1];
      let currExtensionIndex = this.possibleExtensions.indexOf(currExtension);
      let nextExtensionIndex = currExtensionIndex + 1;

      if (nextExtensionIndex == this.possibleExtensions.length) {
        return;
      }

      let nextExtension = this.possibleExtensions[nextExtensionIndex];

      this.promotion.image = encodeURI(
        `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${code}.${nextExtension}`
      );
    },
  },
};
</script>
